import React, { Fragment }  from 'react';
import { times, get, isEmpty} from 'lodash';

import { withNetworkState } from 'ui/hoc/withNetworkState';
import { dateRangePickerPreloader as DateRangePickerPreloader } from 'ui/views/generic/dateRangePicker';
import { BarChart } from 'modules/barChart';
import { barChartPreloader as BarChartPreloader } from 'modules/barChart/barChart.view';
import { reportsFilters as ReportsFiltersView } from 'ui/views/widgets/reportsFilters';
import { getLabel } from 'utils/getLabel';

// import { PieChart } from 'modules/pieChart';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { PieChartHighCharts } from 'ui/containers/PieChartHighCharts';

// import { ColorConfig, ColorConfigInActive } from 'config/piechart-configs/resolution-config';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callResolutionReporting as CallResolutionReporting } from 'ui/views/widgets/callResolutionReporting';
 *
 * // render
 * <CallResolutionReporting propName='propValue'/>
 */
const _callResolutionReporting = ( props ) => {

    const filterFields = getVisibleItems( props.structure.filtersConfig.fields, props.visibility );
    const widgetConfig = props.structure.widgetConfig;

    const chartData = [
        {
            data: props.pieChartData.chartData
        }
    ];

    return (
       
        <div className='ui-call-resolution-reporting'>

            {/* filter view */}
            <ReportsFiltersView
                filterFields={ filterFields }
                filterData={ props.filterData } // options and selected values
                widgetConfig={ widgetConfig }
                onOptionSelect={ props.onOptionSelect }
            />

            <div className='ui-call-resolution-reporting__charts'>
                <div className='ui-call-resolution-reporting__charts__chart' >
                    {
                        ! props.isBarChartFetching && ! isEmpty( get( props, 'barGraphData', {} ) ) ? (
                            <div className='ui-call-resolution-reporting__charts__chart__title'>
                                <div className='ui-call-resolution-reporting__charts__chart__title__text'>
                                    { `${ getLabel( get( props, 'barGraphData.config.widgetConfig.title', {} ) ) }: ` }
                                </div>
                                <div className='ui-call-resolution-reporting__charts__chart__title__count'>
                                    { get( props, 'barGraphData.totalCalls' ) }
                                </div>
                            </div>
                        ) : null
                    }
                    <BarChart
                        data = { props.barGraphData.chartData }
                        className='ui-call-resolution-reporting__charts__chart__bar-chart'
                        isFetching={ props.isBarChartFetching }
                        onClickHandler={ props.onBarChartClickHandler }
                        width={ props.isPieChartVisible ? '880px' : '100%'}
                        networkStatus={ props.barGraphNetworkStatus }
                    />
                </div>

                { props.isPieChartVisible ? (
                    <Fragment>
                        <div className='ui-call-resolution-reporting__charts__division'></div>
                    
                        <div className='ui-call-resolution-reporting__charts__chart'>
                            {
                                ! props.isPieChartFetching ? (
                                    <div className='ui-call-resolution-reporting__charts__chart__title'>
                                        <div className='ui-call-resolution-reporting__charts__chart__title__text'>
                                            { `${ props.pieChartData.duration }: ` }
                                        </div>
                                        <div className='ui-call-resolution-reporting__charts__chart__title__count'>
                                            { props.pieChartData.totalCalls }
                                        </div>
                                    </div>
                                ) : null
                            }

                            {/* <PieChart
                                data = { props.pieChartData.chartData }
                                className='ui-call-resolution-reporting__charts__chart__pie-chart'
                                isFetching={ props.isPieChartFetching }
                            /> */}

                            <PieChartHighCharts
                                data = { chartData }
                                className='ui-call-resolution-reporting__charts__chart__pie-chart'
                                isFetching={ props.isPieChartFetching }
                                chartId={ 'reolution-chart' }
                            />

                          
                        </div>
                    </Fragment>
                ) : null }
            </div>
        </div>
    );
};

// set display name
_callResolutionReporting.displayName = 'callResolutionReporting';

// set default props
_callResolutionReporting.defaultProps = {};

// prop types
_callResolutionReporting.propTypes = {};

/******************************************************** */

const callResolutionReportingPreloader = ( ) => {
    return (
            <div className='ui-call-resolution-reporting-preloader'>
            <div className='ui-call-resolution-reporting-preloader__header'>
                <div className='ui-call-resolution-reporting-preloader__header__title'></div>
                <DateRangePickerPreloader
                    className='ui-call-resolution-reporting-preloader__header__date-range'
                />
                <div className='ui-call-resolution-reporting-preloader__header__cag'>
                    <div className='ui-call-resolution-reporting-preloader__header__cag__title'></div>
                    <div className='ui-call-resolution-reporting-preloader__header__cag__choice'></div>
                </div>
            </div>

            <div className='ui-call-resolution-reporting-preloader__filters'>
                { times( 4 ).map( index => {
                    return (
                        <div key={ index } className='ui-call-resolution-reporting-preloader__filters__filter'>
                            <div className='ui-call-resolution-reporting-preloader__filters__filter__title'></div>
                            <div className='ui-call-resolution-reporting-preloader__filters__filter__options'>
                                { times( 4 ).map( _index => {
                                    return (
                                        <div key={ _index } className='ui-call-resolution-reporting-preloader__filters__filter__options__option'>
                                            <div className='ui-call-resolution-reporting-preloader__filters__filter__options__option__checkbox'></div>
                                            <div className='ui-call-resolution-reporting-preloader__filters__filter__options__option__title'></div>
                                        </div>
                                    );
                                } ) }
                            </div>
                        </div>
                    );
                } ) }
                
            </div>
            <div className='ui-call-resolution-reporting-preloader__chart'>
                <BarChartPreloader />
            </div>
        </div>
    );
};

// set display name
callResolutionReportingPreloader.displayName = 'callResolutionReportingPreloader';

// set default props
callResolutionReportingPreloader.defaultProps = {};

// prop types
callResolutionReportingPreloader.propTypes = {};

export const callResolutionReporting = withNetworkState( callResolutionReportingPreloader, _callResolutionReporting );

